import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, CarCategories, Banner, Services, Partners } from '../../../sections';


 
const AboutUs = () => {
  return ( 
    <>
    
      {/* Page title */}
      <PageTitle title={'about us'} page={'about'} />

      {/* About Page Structure */}
      <section className='about-us'>

        <About /> {/* About Section */}
        <Counter /> {/* Counter Section */}
        <CarCategories /> {/* Top 5 Car Categories */}
        <Banner /> {/* Banner Section */}
        <Services /> {/* Services Section */}
        <Testimonials /> {/* Testimonials Slider */}
        <Team /> {/* Team section */}
        <Partners /> {/* Partners Slider */}

      </section>
    </>
  );
}

export default AboutUs;